import type { Rank } from './game'

export function pipRowsFor(rank: Rank): number[] | null {
  switch (rank) {
    case '2':  return [1, 1]
    case '3':  return [1, 1, 1]
    case '4':  return [2, 2]
    case '5':  return [2, 1, 2]
    case '6':  return [2, 2, 2]
    case '7':  return [2, 3, 2]
    case '8':  return [3, 2, 3]
    case '9':  return [3, 3, 3]
    case '10': return [3, 4, 3]
    default:   return null
  }
}
